import { newE2EPage } from '@stencil/core/testing';

describe('jackery-comment', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-comment></jackery-comment>');

    const element = await page.find('jackery-comment');
    expect(element).toHaveClass('hydrated');
  });
});
